module.exports = function addIcons() {
    const tileLink = document.querySelectorAll('a.view');
    const icon = `<i class="fas fa-chevron-circle-right"></i>`;
    const appendIcon = () => {
        tileLink.forEach((link) => {
            if (link.children.length === 0){
                link.innerHTML += icon;
            }
        });
    };
    appendIcon();
};


// WEBPACK FOOTER //
// ./scriptPartials/addViewLinkIcon.js